export const NOTIFICATIONS_LOAD = 'NOTIFICATIONS_LOAD';
export const NOTIFICATION_TRIGGER = 'NOTIFICATION_TRIGGER';
export const NOTIFICATION_CLEAR = 'NOTIFICATION_CLEAR';
export const NOTIFICATION_CLEAR_TARGET = 'NOTIFICATION_CLEAR_TARGET';
